import _ from 'lodash'
import qs from 'qs'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

export const mapFieldUser = (item, index) => {
  const id = item?.report_header_id
  const orgStructure = item?.employee?.org_structure
  return {
    ...item,
    index,
    key: id,
    id: id,
    name: item?.employee?.employee_name_th,
    organization: `${orgStructure?.company?.company_name}/${orgStructure?.group?.group_name}/${orgStructure?.business_unit?.bu_name}/${orgStructure?.division?.division_name}/${orgStructure?.department?.department_name}/${orgStructure?.section?.section_name}`,
    profile: item?.profile_id,
    role: item?.profile?.role?.role_name || 'None',
    isEnabled: item?.is_active,
    canEdit: item?.can_edit,
    topic: item?.reportcode_cd,
    reporter: item?.reporter?.employee?.employee_name_en || '',
    report_type: item?.report_type?.report_type_name || '',
    status: item?.report_status?.report_status_name_en || '',
  }
}

export const getMyIncidentListApi = ({
  incident_topic,
  reporter,
  risk_co,
  risk_owner,
  date_from,
  date_to,
  page,
  size,
  ...param
}) => {
  const params = removeEmpty({
    ...param,
    incident_topic,
    reporter,
    risk_co,
    risk_owner,
    date_from,
    date_to,
    page,
    size,
  })
  const config = {
    method: 'get',
    url: '/api/v1/incident/',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldUser),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const saveFileFromResponse = (response) => {
  // const filenameRegex = /filename[^;=\n]*\*?=(?:utf-8'')?((['"]).*?\2|[^;\n\\/:*?"<>|]*)$/
  const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
  // const contentDispostion = response.request.getResponseHeader('Content-Disposition')

  const filename = 'incident_template.xlsx'

  const link = document.createElement('a')

  link.href = downloadUrl

  link.setAttribute('download', filename) //any other extension

  document.body.appendChild(link)

  link.click()

  link.remove()
}

export const getMyIncidentTemplete = ({ report_type_id }) => {
  const config = {
    method: 'get',
    url: `/api/v1/incident/export_template/${report_type_id}`,
    responseType: 'blob',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        saveFileFromResponse(res)
      }
      // if (res.data?.items) {
      //   return responseSuccess({
      //     data: {
      //       items: _.map(res.data?.items, mapFieldUser),
      //       total: res.data.total,
      //       page: res.data.page,
      //       size: res.data.size,
      //     },
      //   })
      // }
      return responseSuccess({})
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const mapReportListType = (item) => {
  return {
    ...item,
    key: item?.report_type_id,
    id: item?.report_type_id,
    name: item?.report_type_name,
    description: item?.report_type_description,
  }
}

export const getReportTypeListApi = () => {
  const config = {
    method: 'get',
    url: `/api/v1/report_type/`,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res.data?.items, mapReportListType) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const mapReportStatus = (item) => {
  return {
    ...item,
    key: item?.report_status_id,
    id: item?.report_status_id,
    name: item?.report_status_name_th,
  }
}

export const getReportStatusListApi = () => {
  const config = {
    method: 'get',
    url: `/api/v1/filters/report_status`,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: _.map(res?.data, mapReportStatus) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const updateMergeMyIncidentApi = ({ report_header_id, reportHeaderId }) => {
  const data = {
    report_header_id,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/incident/merge_incident/${reportHeaderId}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateUnmergeMyIncidentApi = ({ report_header_id }) => {
  const config = {
    method: 'patch',
    url: `/api/v1/incident/unmerge_incident/${report_header_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteMyIncidentByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/incident/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const importMyIncidentApi = ({ file, report_type_id }) => {
  const data = {
    file,
    report_type_id,
  }
  const formData = new FormData()
  formData.append('file', data?.file)

  const config = {
    method: 'post',
    url: `/api/v1/incident/import/${report_type_id}`,
    data: formData,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateSubmitMyIncidentApi = ({ report_header_id }) => {
  const config = {
    method: 'post',
    url: `/api/v1/incident/submit_report/${report_header_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateRejectMyIncidentApi = ({ report_header_id, reject_description }) => {
  const config = {
    method: 'post',
    url: `/api/v1/incident/reject_report/${report_header_id}`,
    data: { reject_description },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateReOpenMyIncidentApi = ({ report_header_id }) => {
  const config = {
    method: 'post',
    url: `/api/v1/incident/reopen_report/${report_header_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createMyIncidentApi = ({ ...param }) => {
  const config = {
    method: 'post',
    url: `/api/v1/incident/`,
    data: param,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return {
          ...res,
          status: 'success',
        }
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateMyIncidentApi = ({ report_header_id, data }) => {
  const config = {
    method: 'patch',
    url: `/api/v1/incident/${report_header_id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getMyIncidentApi = ({ report_header_id, ...param }) => {
  const params = removeEmpty({
    ...param,
  })

  const config = {
    method: 'get',
    url: `/api/v1/incident/${report_header_id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        return responseSuccess({ data: res?.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getOptionsBusinessProcessApi = ({ ...param }) => {
  const params = removeEmpty({
    ...param,
    // bu_id,
  })
  const config = {
    method: 'get',
    url: '/api/v1/filters/business_process',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        return responseSuccess({ data: res?.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getUserListApi = ({
  company_id,
  group_id,
  bu_id,
  division_id,
  department_id,
  section_id,
  profile_id,
  role_id,
  employee_name,
  is_active,
  page,
  size,
}) => {
  const params = removeEmpty({
    company_id,
    group_id,
    bu_id,
    division_id,
    department_id,
    section_id,
    profile_id,
    role_id,
    employee_name,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: '/api/v1/user/',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: res.data?.items,
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getUserFilterList = ({ ...param }) => {
  const params = removeEmpty({
    ...param,
  })
  const config = {
    method: 'get',
    url: `/api/v1/filters/user`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getRiskOwnerOrgFilterList = () => {
  const config = {
    method: 'get',
    url: `/api/v1/filters/risk_owner_org`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
